import { iDateService } from './date.types';

export class DateService implements iDateService {
  private moment: any;

  constructor(moment: any) {
    this.moment = moment;
  }

  now(): number {
    return +this.moment().format('X');
  }
}
